import { useEffect } from "react";
import { useHistory } from "react-router";
// Components

// Images
import salesBanner from '../../assets/img/partnerPortal/sales/Half Wave.svg';
import email from '../../assets/img/general/email.svg';
import arrowButton from '../../assets/img/partnerPortal/homepage/arrow-right-white.png';

// Scss
import '../../assets/css/partnerProgram.scss';
import '../../assets/css/partnerPortal/welcome.scss';



import Title from "../../components/Title";

function UnauthorizedAccess() {

  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();


  }, []);

    const TITLE = "Unauthorized Access";
    const SUB_TITLE = <div>You do not have permission to access the Dynatrace Partner Portal.<br/><br/>
                        The Partner portal is just for partners of Dynatrace with an active contract. If it is the case of your company, please fill out the form registration linked below. 
                        <br/><br/>If you already register and you are still with problems, contact our support team for assistance.</div>;
    const BUTTON_NAME_1 = "registration form";
    const BUTTON_LINK_1= "https://partners.dynatrace.com/#/page/registration";
    const BUTTON_NAME_2 = "Contact Partner Operations";
    const BUTTON_LINK_2= "mailto:partneroperations@dynatrace.com";

  return (
    <>
        <div className="mb-3">
            <div className="d-flex flex-column align-items-center mb-3 w-100">
                <img src={salesBanner} className=' shadow-4 imageBannerSales' alt='...' />
                <div className="d-flex row w-100 marginsAssociate">
                    <div className="d-flex pt-4 flex-column align-items-start justify-content-center width42 mr-5">
                        <div className="d-flex align-items-start pb-4">
                            <Title classNameText="salesTitle" title={TITLE} withoutLine={true}/>
                        </div>
                        <div className="d-flex align-items-start">
                            <div className="subCopyLetters mb-3">
                                {SUB_TITLE}
                            </div>
                        </div>
                        <div className="d-flex align-items-center align-self-stretch mt-3 w-100">
                            <div className="d-flex flex-column align-items-start justify-content-center mr-4">
                                <a href={BUTTON_LINK_1} target="_parent"  >
                                    <div className="d-flex align-items-center justify-content-center buttonBackgroundUnauthorized">
                                        <div className="buttonRegistrationPage">{BUTTON_NAME_1}</div>
                                        <img src={arrowButton}  alt='...' width={"12%"}  />

                                    </div>
                                </a>
                            </div>
                            <div className="d-flex flex-column align-items-start justify-content-center w-50">
                                <a href={BUTTON_LINK_2} target="_parent" className="w-100"  >
                                    <div className="d-flex align-items-start justify-content-center">
                                        <img src={email}  alt='...' width={"8%"}  />
                                        <div className="d-flex flex-column align-items-start w-100 ChangeLineColor">
                                            <div className="d-flex align-items-start buttonMail">{BUTTON_NAME_2}</div>
                                            <div className="lineBlack3"></div>

                                        </div>
                                    </div>
                                </a>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  );

  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default UnauthorizedAccess;

